import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { getRescheduleHistoryInput, RescheduleHistoryModel } from './model';

export function useGetRescheduleHistory(
  input?: getRescheduleHistoryInput,
  options?: UseQueryOptions<ApiResult<RescheduleHistoryModel[]>, ApiError>,
): UseQueryResult<ApiResult<RescheduleHistoryModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getRescheduleHistory', input],
      () =>
        QueryFetchFunction({
          url: `${input?.type}-sales/${input?.saleId}/reschedule-histories`,
        }),
      options,
    ),
    RescheduleHistoryModel,
  );
}

export function getRescheduleHistoryKey(input?: getRescheduleHistoryInput) {
  return ['getRescheduleHistory', input];
}
